import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/gravatar-compound-1.png")